import timezz from "timezz";
export function clockTNT(timestamp_livraison) {
  if ($("#clock").length) {
    timezz(document.querySelector("#clock"), {
      date: timestamp_livraison,
    });
  }
}
